import { Injectable } from '@angular/core';
import { Object3D } from 'three';
import { CSS2DObject } from 'three/examples/jsm/renderers/CSS2DRenderer';
@Injectable({
  providedIn: 'root',
})
export class DetailsPopupService {
  private _monotainerDetails: Map<string, any> = new Map<string, any>();
  private _laneDetails: Map<string, any> = new Map<string, any>();
  private _mesh: Object3D;
  private _css2dObjects: Object3D[] = [];
  private _monotainerTag: Object3D[] = [];
  private _productLabelMonotainer: CSS2DObject;
  private _productLabelLane: CSS2DObject;
  private _lableContainer:Object3D;
  constructor() {}

  /**
   * Appends alert monotainer
   * adds the pop up to the monotainer
   * @param mesh
   */
  appendAlertMonotainer(mesh: Object3D) {
    this._mesh = mesh;
    const wrapper = document.createElement('div');
    const details = this._monotainerDetails.get(mesh.name);
    if (details) {
      if (details.state !== 'untagged') {
        const taggedTime: Date = new Date(details.taggedTime);
        const hours: number = taggedTime.getHours();
        const minutes: string = taggedTime
          .getMinutes()
          .toString()
          .padStart(2, '0');
        const period: string = hours >= 12 ? 'PM' : 'AM';
        const formattedHours: string = (hours % 12 || 12)
          .toString()
          .padStart(2, '0'); // Convert to 12-hour format
        const formattedTime: string = `${formattedHours}:${minutes} ${period}`;

        wrapper.innerHTML = [
          `<div class="alert alert-light" role="alert" style="width: 8rem; font-size: x-small; height: auto; padding: 5px; position: relative;">
          <button type="button" class="close" data-dismiss="alert" aria-label="Close" style="position: absolute; top: -8px; right: -8px; box-shadow:none;">
          <span aria-hidden="true">&times;</span>
          </button>
          <h6 class="card-title" style="margin-bottom: 5px">${details.name}</h6>
          <p style="margin:0">Tag ID -${details.tagId}</p>
          <p style="margin:0">Tag time-${formattedTime}</p>
          <p style="margin:0">Dest-${details.destination}</p>
          <p style="margin:0">TAT-${details.tat}</p>
      </div>`,
        ].join('');
      } else {
        wrapper.innerHTML = [
          `<div  class="alert alert-light" role="alert" style="width: 8rem; font-size: x-small; height: 4rem; padding:5px">
          <button type="button" class="close" data-dismiss="alert" aria-label="Close" style="position: absolute; top: 0; right: 0; box-shadow:none;">
          <span aria-hidden="true">&times;</span>
      </button>
        <h6 class="card-title" style="margin-bottom: 5px">${mesh.name}</h6>
        <p><strong>Untagged</strong></p>
      `,
        ].join('');
      }
    } else {
      wrapper.innerHTML = [
        `<div  class="alert alert-light" role="alert" style="width: 8rem; font-size: x-small; height: 4rem; padding:5px">
        <button type="button" class="close" data-dismiss="alert" aria-label="Close" style="position: absolute; top: 0; right: 0; box-shadow:none;">
              <span aria-hidden="true">&times;</span>
          </button>
    <h6 class="card-title" style="margin-bottom: 5px">${mesh.name}</h6>
    
  `,
      ].join('');
    }
    wrapper.className = 'label';
    wrapper.style.marginTop = '-1em';
    this._productLabelMonotainer = new CSS2DObject(wrapper);
    this._productLabelMonotainer.scale.set(0.009, 0.009, 0.009);
    this._productLabelMonotainer.position.set(-1, 10, -1);
    this._productLabelMonotainer.name = 'label';
    mesh.add(this._productLabelMonotainer);
    wrapper.addEventListener('mouseup',(event)=>{
      event.stopPropagation();
      this.removeAlertfromIcon(mesh);
    })
    this._css2dObjects.push(mesh);
    if (this._monotainerTag) {
      this._monotainerTag.forEach((mesh) => {
        if (mesh != undefined && mesh.name!=this._productLabelMonotainer.parent.name) {
          mesh.traverse(function (child) {
            if (child.name === 'icon') {
              child.visible = false;
            }
          });
        }
      });
    }
  }
  /**
   * Appends alert lane
   * appends popup to lane
   * @param mesh
   */
  appendAlertLane(mesh: Object3D) {
    this._mesh = mesh;
    const details = this._laneDetails.get(mesh.name);
    const wrapper = document.createElement('div');
    let htmlString = `
    <div style="width: 100%; height: 100%; position: relative; transform: scale(0.7);">
    <div style="width: 307px; height: 263px; left: 98px; top: 0px; position: absolute; background: #1F1D2B; border-radius: 5px">
    <button type="button" class="close" data-dismiss="alert" aria-label="Close" style="position: absolute; top: 5px; right: 5px; color: #FFFFFF;">
      <span aria-hidden="true">&times;</span>
    </button>
    </div>
    <div style="width: 48px; height: 33px; left: 118px; top: 161px; position: absolute; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 2px; display: inline-flex">
        <div style="color: #A8A7AD; font-size: 10px; font-family: Inter; font-weight: 400; line-height: 12px; word-wrap: break-word">Sort Area</div>
        <div style="color: #FFFFFF; font-size: 16px; font-family: Inter; font-weight: 500; line-height: 19px; word-wrap: break-word">${details.waitingCount}</div>
    </div>
    <div style="width: 37px; height: 33px; left: 119px; top: 212px; position: absolute; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 2px; display: inline-flex">
        <div style="color: #A8A7AD; font-size: 10px; font-family: Inter; font-weight: 400; line-height: 12px; word-wrap: break-word">Missing</div>
        <div style="color: #FFFFFF; font-size: 16px; font-family: Inter; font-weight: 500; line-height: 19px; word-wrap: break-word">${details.missingCount}</div>
    </div>
    <div style="width: 37px; height: 33px; left: 217px; top: 212px; position: absolute; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 2px; display: inline-flex">
        <div style="color: #A8A7AD; font-size: 10px; font-family: Inter; font-weight: 400; line-height: 12px; word-wrap: break-word">Outside</div>
        <div style="color: #FFFFFF; font-size: 16px; font-family: Inter; font-weight: 500; line-height: 19px; word-wrap: break-word">${details.outsideCount}</div>
    </div>
    <div style=" width: 48px; height: 33px; left: 217px; top: 161px; position: absolute; color: #A8A7AD; font-size: 10px; font-family: Inter; font-weight: 400; line-height: 12px; word-wrap: break-word">In Lane</div>
    <div style="left: 217px; top: 175px; position: absolute; color: #FFFFFF; font-size: 16px; font-family: Inter; font-weight: 500; line-height: 19px; word-wrap: break-word">${details.insideCount}</div>
    <div style="left: 324px; top: 161px; position: absolute; color: #A8A7AD; font-size: 10px; font-family: Inter; font-weight: 400; line-height: 12px; word-wrap: break-word">Misplaced</div>
    <div style="left: 324px; top: 175px; position: absolute; color: #FFFFFF; font-size: 16px; font-family: Inter; font-weight: 500; line-height: 19px; word-wrap: break-word">${details.mismatchCount}</div>
    <div style="width: 69px; left: 118px; top: 18px; position: absolute; color: #FFFFFF; font-size: 18px; font-family: Inter; font-weight: 600; word-wrap: break-word">${details.zoneName}</div>
    <div style="width: 117px; height: 17px; left: 118px; top: 51px; position: absolute">
        <div style="left: 0px; top: 3px; position: absolute; color: #A8A7AD; font-size: 11px; font-family: Inter; font-weight: 400; word-wrap: break-word">Destination</div>
        <div style="left: 65px; top: 0px; position: absolute; color: #FFFFFF; font-size: 14px; font-family: Inter; font-weight: 500; word-wrap: break-word">${details.destination}</div>
    </div>
    <div style="width: 74px; height: 17px; left: 118px; top: 73px; position: absolute">
        <div style="left: 0px; top: 3px; position: absolute; color: #A8A7AD; font-size: 11px; font-family: Inter; font-weight: 400; word-wrap: break-word">Active Tags</div>
        <div style="left: 65px; top: 0px; position: absolute; color: #FFFFFF; font-size: 14px; font-family: Inter; font-weight: 500; word-wrap: break-word">${details.activeTags}</div>
    </div>
    <div style="width: 135px; height: 17px; left: 118px; top: 95px; position: absolute">
        <div style="left: 0px; top: 3px; position: absolute; color: #A8A7AD; font-size: 11px; font-family: Inter; font-weight: 400; word-wrap: break-word">Batch Occupancy</div>
        <div style="left: 98px; top: 0px; position: absolute; color: #FFFFFF; font-size: 14px; font-family: Inter; font-weight: 500; word-wrap: break-word">${details.occupancyPct}%</div>
    </div>
    <div style="width: 132px; height: 17px; left: 118px; top: 117px; position: absolute">
        <div style="left: 0px; top: 3px; position: absolute; color: #A8A7AD; font-size: 11px; font-family: Inter; font-weight: 400; word-wrap: break-word">Average TAT</div>
        <div style="left: 70px; top: 0px; position: absolute; color: #FFFFFF; font-size: 14px; font-family: Inter; font-weight: 500; word-wrap: break-word">${details.batchTat}</div>
    </div>
</div>
    `;
    wrapper.innerHTML = htmlString;
    wrapper.className = 'label';
    wrapper.style.marginTop = '-1em';
    this._productLabelLane = new CSS2DObject(wrapper);
    this._css2dObjects.push(this._productLabelLane);
    this._productLabelLane.scale.set(0.001, 0.001, 0.001);
    this._productLabelLane.position.set(-20, 40,70);
    this._productLabelLane.name = 'label';
    this._productLabelLane.renderOrder=Infinity
    wrapper.addEventListener('mouseup',(event)=>{
      event.stopPropagation();
      this.removeAlertfromIcon(mesh);
    })
    mesh.add(this._productLabelLane);
  }

/**
 * Appends name forklift
 * @param mesh 
 * @param taggedList 
 */
appendNameForklift(mesh: Object3D, taggedList: string[]) {
  this._lableContainer=new Object3D();
  this._lableContainer.name="labelContainer";
  taggedList.forEach((tag, index) => {
    const label = this.createLabel(tag); 
    label.position.set(0, index * 15, 0);
    label.name="label";
   this. _lableContainer.add(label); 
  });
  mesh.add(this._lableContainer); 
}

createLabel(tag: string): CSS2DObject {
  const wrapper = document.createElement('div');
  wrapper.innerHTML = `
    <div class="alert alert-light" role="alert" style="width: auto; font-size: x-small; padding: 2px; margin: 0;">
      <p class="card-title" style="margin: 0;"><strong>${tag}</strong> Tagged</p>
    </div>
  `;
  wrapper.className = 'label';
  wrapper.style.marginTop = '-1em';
  const labelObject = new CSS2DObject(wrapper);
  labelObject.scale.set(0.009, 0.009, 0.009);
  return labelObject;
}

  /**
   * Appends icon green to inLane monotainer
   * @param mesh
   */
  appendIcon(mesh: Object3D, color:string) {
    const wrapper = document.createElement('div');
    wrapper.innerHTML = [
      `<div style="width: 100%; height: 100%; position: relative">
            <div style="width: 20px; height: 20px; left: 0px; top: 0px; position: absolute; background: rgba(9, 98, 160, 0.20); border-radius: 9999px"></div>
            <div style="width: 10px; height: 10px; left: 6.5px; top: 6.5px; position: absolute; background: #${color}; box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.50); border-radius: 9999px; border: 1px white solid"></div>
        </div> 
          `,
    ].join('');
    wrapper.className = 'label';
    wrapper.style.marginTop = '-1em';
    const label = new CSS2DObject(wrapper);
    label.scale.set(0.005, 0.005, 0.005);
    label.position.set(0, 1, 0);
    label.name = 'icon';
    mesh.add(label);
    wrapper.addEventListener('click',(event)=>{
      event.stopPropagation();
      this.appendAlertMonotainer(label.parent);
    })
    wrapper.addEventListener('mouseup',(event)=>{
      event.stopPropagation();
      this.removeAlertfromIcon(label.parent);
    })
    this._css2dObjects.push(mesh);
    this._monotainerTag.push(mesh);
  }
  
  /**
   * Removes alert from 3d meshes
   */
  removeAlert() {
    if (this._mesh != undefined) {
      this._mesh.traverse(function (child) {
        if (child.name === 'label') {
          child.removeFromParent();
        }
      });
    }
    if (this._monotainerTag) {
      this._monotainerTag.forEach((mesh) => {
        if (mesh != undefined) {
          mesh.traverse(function (child) {
            if (child.name === 'icon') {
              child.visible = true;
            }
            if (child.name === 'label') {
              child.removeFromParent();
            }
          });
        }
      });
    }
  }

  /**
   * Removes alertfrom icon
   * @param mesh 
   */
  removeAlertfromIcon(mesh:Object3D)
  {
    if (mesh != undefined) {
      mesh.traverse(function (child) {
        if (child.name === 'label') {
          child.removeFromParent();
        }
      });
    }
    if (this._monotainerTag) {
      this._monotainerTag.forEach((mesh) => {
        if (mesh != undefined) {
          mesh.traverse(function (child) {
            if (child.name === 'icon') {
              child.visible = true;
            }
          });
        }
      });
    }

  }
  /**
   * Removes icon from meshes
   * @param mesh
   */
  removeIcon(mesh: Object3D) {
    if (mesh != undefined) {
      mesh.traverse(function (child) {
        if (child.name === 'icon') {
          child.removeFromParent();
        }
      });
    }
  }

  /**
   * Removes alert from forklift
   * @param forklift 
   * @returns alert from forklift 
   */
  removeAlertFromForklift(forklift: Object3D): Promise<void> {
    return new Promise((resolve) => {
      const removeChildren = (parent) => {
        parent.children.forEach((child) => {
          parent.remove(child); 
          removeChildren(child); 
        });
      };
  
      const checkAndResolve = () => {
        if (this._lableContainer.children.length === 0) {
          resolve(); 
        } else {
          removeChildren(this._lableContainer);
          setTimeout(checkAndResolve, 100); 
        }
      };
  
      if (forklift !== undefined) {
        checkAndResolve();
      } else {
        resolve();
      }
    });
  }
  /**
   * Sets details of Monotainers
   * @param details
   */
  setDetailsMonotianer(details: any) {
    this._monotainerDetails = details;
  }

  /**
   * Sets details of lane
   * @param details
   */
  setLaneDetails(details: any) {
    this._laneDetails = details;
  }

  getCSS2DLabel():CSS2DObject
  {
    return this._productLabelLane;
  }


}
